import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Typography,
  List,
  ListItem,
  ListItemText,
  ListItemIcon,
  Divider,
  Box,
  Alert,
  AlertTitle,
  Paper,
} from "@mui/material";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import ErrorIcon from "@mui/icons-material/Error";
import WarningIcon from "@mui/icons-material/Warning";

/**
 * Modal to show the detailed result of the mass allocation
 * Manages successes, total failures and mixed states
 *
 * @param {object} props
 * @param {boolean} props.open
 * @param {function} props.onClose
 * @param {object} props.result
 */

const AssignmentResultModal = ({ open, onClose, result }) => {
  if (!result) return null;

  const { summary, failed_deliveries: failedDeliveries } = result;
  const hasFailures = summary.failed_count > 0;
  const hasSuccess = summary.success_count > 0;

  let severity = "info";
  let title = "Resultado";
  let MainIcon = WarningIcon;

  if (hasSuccess && !hasFailures) {
    severity = "success";
    title = "¡Asignación Exitosa!";
    MainIcon = CheckCircleIcon;
  } else if (!hasSuccess && hasFailures) {
    severity = "error";
    title = "Error en la Asignación";
    MainIcon = ErrorIcon;
  } else if (hasSuccess && hasFailures) {
    severity = "warning";
    title = "Asignación Parcial";
    MainIcon = WarningIcon;
  }

  return (
    <Dialog open={open} onClose={onClose} fullWidth maxWidth="sm">
      <DialogTitle sx={{ display: "flex", alignItems: "center", gap: 1 }}>
        <MainIcon color={severity} />
        {title}
      </DialogTitle>

      <DialogContent dividers>
        <Box sx={{ mb: 2 }}>
          <Alert severity={severity} variant="outlined">
            <AlertTitle>Resumen</AlertTitle>
            <Typography variant="body2">
              Solicitados: <strong>{summary.total_requested}</strong>
            </Typography>
            <Typography variant="body2">
              Procesados correctamente: <strong>{summary.success_count}</strong>
            </Typography>
            <Typography variant="body2">
              Fallidos: <strong>{summary.failed_count}</strong>
            </Typography>
          </Alert>
        </Box>
        {hasFailures && (
          <>
            <Typography variant="subtitle2" color="error" sx={{ mt: 2, mb: 1 }}>
              Detalle de errores ({failedDeliveries.length}):
            </Typography>
            <Paper variant="outlined" sx={{ maxHeight: 200, overflow: "auto" }}>
              <List dense>
                {failedDeliveries.map((fail, index) => (
                  <div key={fail.id || index}>
                    <ListItem alignItems="flex-start">
                      <ListItemIcon sx={{ minWidth: 35 }}>
                        <ErrorIcon color="error" fontSize="small" />
                      </ListItemIcon>
                      <ListItemText
                        primary={
                          <Typography variant="subtitle2">
                            Ref: {fail.reference_id || `ID: ${fail.id}`}
                          </Typography>
                        }
                        secondary={fail.message}
                        primaryTypographyProps={{ fontWeight: "bold" }}
                      />
                    </ListItem>
                    {index < failedDeliveries.length - 1 && (
                      <Divider component="li" />
                    )}
                  </div>
                ))}
              </List>
            </Paper>
          </>
        )}
      </DialogContent>

      <DialogActions>
        <Button onClick={onClose} variant="contained" color="primary">
          Entendido
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default AssignmentResultModal;
